"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @category Guard
 * @returns `true` if the value is an array
 * @example
 * ```typescript
 *   if(isArray(value)) return value.map((e) =>({ e }));
 * ```
 */
const isArray = ((value) => {
    return Array.isArray(value);
});
exports.default = isArray;
